export const FETCH_IAT_TASK_REQUEST = 'FETCH_IAT_TASK_REQUEST'
export const FETCH_IAT_TASK_SUCCESS = 'FETCH_IAT_TASK_SUCCESS'
export const FETCH_IAT_TASK_FAILURE = 'FETCH_IAT_TASK_FAILURE'

export const ANSWER_IAT_TASK_REQUEST = 'ANSWER_IAT_TASK_REQUEST'
export const ANSWER_IAT_TASK_SUCCESS = 'ANSWER_IAT_TASK_SUCCESS'
export const ANSWER_IAT_TASK_FAILURE = 'ANSWER_IAT_TASK_FAILURE'
